import type { WithIntlProps, WrappedComponentProps } from 'react-intl';

import type { EmptyStateHandlerParams } from '@atlaskit/editor-common/types/empty-state-handler';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const MarketplaceAppsContainer: LoadableType<
	WithIntlProps<EmptyStateHandlerParams & WrappedComponentProps>
> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AppsContainer" */ './AppsContainer.tsx'))
			.MarketplaceAppsContainer,
});
